import React from 'react';
import { Image } from '@edreamsodigeo/prisma-design-system';

interface CarrierImageProps {
  alt: string;
  src: string;
}

const CarrierImage: React.FC<CarrierImageProps> = ({ alt, src }) => (
  <Image src={src} alt={alt} size={'small'} rounded />
);

export default CarrierImage;
